export const ExcelFormulas = {
  PMT: function (rate: number, nper: number, pv: number, fv: number, type: number): number {
    if (!fv) fv = 0;
    if (!type) type = 0;

    if (rate === 0) return -(pv + fv) / nper;

    const pvif = Math.pow(1 + rate, nper);
    let pmt = (rate / (pvif - 1)) * -(pv * pvif + fv);

    if (type === 1) {
      pmt /= 1 + rate;
    }

    return pmt;
  },

  FV: function (rate: number, nper: number, pmt: number, pv: number, type: number): number {
    if (!type) type = 0;

    const pow = Math.pow(1 + rate, nper);
    let fv = 0;

    if (rate) {
      fv = (pmt * (1 + rate * type) * (1 - pow)) / rate - pv * pow;
    } else {
      fv = -1 * (pv + pmt * nper);
    }

    return fv;
  },

  IPMT: function (pv: number, pmt: number, rate: number, per: number): number {
    const tmp = Math.pow(1 + rate, per);
    return 0 - (pv * tmp * rate + pmt * (tmp - 1));
  },

  PPMT: function (rate: number, per: number, nper: number, pv: number, fv: number, type: number): number {
    if (per < 1 || per >= nper + 1) return 0;
    const pmt = this.PMT(rate, nper, pv, fv, type);
    const ipmt = this.IPMT(pv, pmt, rate, per - 1);
    return pmt - ipmt;
  },

  XNPV: function (rate: number, cashflow: number[]): number {
    let xnpv = 0.0;
    for (let i = 0; i < cashflow.length; i++) {
      xnpv += cashflow[i] / Math.pow(1 + rate, i / 12);
    }
    return xnpv;
  },

  XIRR: function (values: number[], guess: number = 0.5): number {
    let x1 = 0.0;
    let x2 = guess;
    let f1 = this.XNPV(x1, values);
    let f2 = this.XNPV(x2, values);

    for (let i = 0; i < 100; i++) {
      if (f1 * f2 < 0.0) {
        break;
      }
      if (Math.abs(f1) < Math.abs(f2)) {
        f1 = this.XNPV((x1 += 1.6 * (x1 - x2)), values);
      } else {
        f2 = this.XNPV((x2 += 1.6 * (x2 - x1)), values);
      }
    }

    if (f1 * f2 > 0.0) {
      return -1;
    }

    const f = this.XNPV(x1, values);
    let rtb, dx;
    if (f < 0.0) {
      rtb = x1;
      dx = x2 - x1;
    } else {
      rtb = x2;
      dx = x1 - x2;
    }

    for (let i = 0; i < 100; i++) {
      dx *= 0.5;
      const x_mid = rtb + dx;
      const f_mid = this.XNPV(x_mid, values);
      if (f_mid <= 0.0) rtb = x_mid;
      if (Math.abs(f_mid) < 1.0e-6 || Math.abs(dx) < 1.0e-6) {
        return x_mid;
      }
    }

    return -1;
  },
};
